import { useMutation } from "@tanstack/react-query";
import { api } from "../context";
import { PrescriptionDetail, RequestDetail } from "../interfaces";

interface UpdatePrescriptionDetailProps {
  requestId: string;
  detailId: string;
  prescriptionDetail: PrescriptionDetail;
}

export const useUpdatePrescriptionDetail = () => {
  return useMutation({
    mutationFn: async ({
      requestId,
      detailId,
      prescriptionDetail,
    }: UpdatePrescriptionDetailProps): Promise<RequestDetail> => {
      const response = await api<RequestDetail>({
        method: "patch",
        url: `/requests/${requestId}/detail/${detailId}`,
        data: JSON.stringify(prescriptionDetail),
      });
      return response;
    },
  });
};
